import AdminList from '../../components/AdminList/adminList'

export default function Example() {
  return (
    <>
      <div>
        <div className="">
          <div className="mx-auto flex flex-col">
            <h1 className="mt-2 text-xl font-semibold text-gray-900">Administrators</h1>
            <AdminList />
          </div>
        </div>
      </div>
    </>
  )
}
